import React, { useState, useContext } from 'react'


const SystemContext = React.createContext()

const useSystem = () => {
	const c = useContext(SystemContext);
	if (!c) throw new Error("useSystem must be used in SystemProvider");
	return c;
};

const SystemProvider = ({children}) =>{

	const [system, setSystem] = useState();

	return (
		<SystemContext.Provider value={{system, setSystem}}>
			{children}
		</SystemContext.Provider>
	)

}

export default SystemContext;
export { useSystem, SystemProvider };